import { Box } from '@mui/material';
import { PropsWithChildren } from 'react';

const ROOT_SX = {
  mt: 0.5,
  minHeight: 18,
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  minWidth: 0,
  overflow: 'hidden',
} as const;

const InterruptionCreatorRoot = ({ children }: PropsWithChildren) => <Box sx={ROOT_SX}>{children}</Box>;

export default InterruptionCreatorRoot;
